import type { ComponentPublicInstance, MaybeRefOrGetter } from 'vue';

import { computed, ref, toValue, useId } from 'vue';

import { useChartGeometry } from './use-chart-geometry';
import { useChartPointer } from './use-chart-pointer';

export const useChartCanvas = (idPrefix: string, label: MaybeRefOrGetter<string>, count: MaybeRefOrGetter<number>) => {
  const titleId = `${idPrefix}-${useId()}`;
  const svgRef = ref<SVGSVGElement | null>(null);
  const { geometry, isMeasured } = useChartGeometry(svgRef);
  const pointer = useChartPointer({
    bounds: (svgBounds) => ({
      left: svgBounds.left + geometry.value.plotLeft,
      width: geometry.value.plotWidth,
    }),
    count,
    isMeasured,
  });
  const bindElement = (element: Element | ComponentPublicInstance | null): void => {
    svgRef.value = element instanceof SVGSVGElement ? element : null;
  };
  const canvas = computed(() => ({
    bindElement,
    isMeasured: isMeasured.value,
    label: toValue(label),
    onCancel: pointer.handlePointerLeave,
    onLeave: pointer.handlePointerLeave,
    onMove: pointer.handlePointerMove,
    titleId,
  }));

  return {
    activeIndex: pointer.activeIndex,
    activeViewportAnchor: pointer.activeViewportAnchor,
    canvas,
    geometry,
  };
};
